module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Titel","data":"Daten","cancel":"abbrechen","save":"speichern","name":"Name","azure_group":"Entra-Gruppe","is_common":"Allgemeines Modul"},"en":{"title":"Title","data":"Data","cancel":"cancel","save":"save","name":"Name","azure_group":"Entra group","is_common":"Common module"}}')
  delete Component.options._Ctor
}
